import $ from 'jQuery';
import machine_app_prerequisite_view_style from './machine_app_prerequisite_view.css';
import machine_app_state from '../models/machine_app_state';
import machine_app_implementation_loader from '../models/machine_app_implementation_loader';
import environment from '../../environment';
import { greenCheckbox } from '../components/machine_app_green_checkbox';
import { prerequisiteValidator } from '../machine_app_prerequisite_validation';
import { transformToTitleCase } from '../../helpers';


/**
 * Responsible for generating the list of prerequisites to using MachineApp.
* @param {MachineAppLibrary} pMachineAppLibrary
*/

export const renderPrerequisiteView = (pMachineAppLibrary) => {
  const machineAppInterface = machine_app_state.getInterface();
  const appType = pMachineAppLibrary.getType();
  const designTemplatesLink = machine_app_implementation_loader.instance.getFlavorText(appType).designTemplatesLink;
  const validation = prerequisiteValidator(appType);
  const configSummary = validation.configSummary;

  const prereqViewContainer = $('<div>')
    .addClass('machine_app_prereq_view_container');
  const exclamationIcon = $('<i>')
    .addClass('fas fa-exclamation-circle machine_app_prereq_view_container_exclamation_icon');
  const explanationText = $('<p>')
    .addClass('machine_app_prereq_view_explanation')
    .text('You are missing design elements to use this MachineApp');
  const instructions = $('<p>')
    .text('To use this MachineApp, your design requires the following to be configured:');
  const prerequisiteList = getPrerequisiteList(configSummary, machineAppInterface);
  const configureNowButton = $('<button>')
    .text('Configure Now')
    .addClass('machine_app_prereq_view_configure_now_button')
    .on('click', () => machineAppInterface.redirectMachineAppToConfigure());
  let exploreTemplatesText = undefined;

  if(designTemplatesLink && environment.isOnCad()){
    const exploreTemplateLink = $('<a>')
      .text(designTemplatesLink.text)
      .attr('href', designTemplatesLink.href)
      .attr('target', '_blank' )
      .prop('outerHTML');

    exploreTemplatesText = $('<p>')
      .html(`Or explore these ${exploreTemplateLink} to get started`);
  }

  return prereqViewContainer.append(
    exclamationIcon,
    explanationText,
    instructions,
    prerequisiteList,
    configureNowButton,
    exploreTemplatesText
  );

};

function getPrerequisiteList(configSummary, machineAppInterface) {
  const prerequisiteList = $('<div>').addClass('machine_app_prerequisite_view_list');

  Object.keys(configSummary).forEach(item => {
    if(configSummary[item].isRequired){
      const isConfigured = configSummary[item].isConfigured;
      const capitalizedItem = transformToTitleCase(item);
      const itemWithQty = `${capitalizedItem} ( ${configSummary[item].qtyConfigured} / ${configSummary[item].qtyRequired} )`;
      const configItemButtonText = isConfigured ? capitalizedItem : itemWithQty;

      const listItem = $('<div>')
        .addClass('machine_app_prereq_view_list_item')
        .append(greenCheckbox(isConfigured).widget)
        .append($('<button>')
          .addClass('machine_app_prereq_view_list_item_button')
          .text(configItemButtonText)
          .on('click', () => {
            machineAppInterface.redirectMachineAppToConfigure();
          })
          .attr('disabled', isConfigured)
        );
      prerequisiteList.append(listItem);
    }

  });
  return prerequisiteList;
}
